import { render, staticRenderFns } from "./Bwr.vue?vue&type=template&id=5a8ea1f6&"
import script from "./Bwr.vue?vue&type=script&lang=js&"
export * from "./Bwr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports